import { render, staticRenderFns } from "./TuitionMassNotification.vue?vue&type=template&id=2372e776&"
import script from "./TuitionMassNotification.vue?vue&type=script&lang=js&"
export * from "./TuitionMassNotification.vue?vue&type=script&lang=js&"
import style0 from "./TuitionMassNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports